'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../../components/buttons/Button';
import {ListItem} from '../../../components/lists/ListItem';
import {I18nMessage} from '../../../components/I18nMessage';
import {AvatarColors} from '../../../core-utilities/domain/AvatarColors';
import {orgModelShape} from '../../../app/navigation/redux/organizations';
import {AvatarImage} from '../../../files/components/AvatarImage';
import {getInitials, PeopleItem} from '../../../personnel/components/PeopleItem';
import {ORGANIZATION_COLLECTION} from '../../domain/config';


// TODO: implement me
export function OrgCardView(props) {
  const model = props.model;

  return (
    <ListItem
      className={classNames("OrgCard", props.className)}
      bindParam={model}
      onClick={props.onClick}
      onContextMenu={props.onShowOptions}
    >
      <AvatarImage
        iconClass="OrgCard__avatar"
        avatarInitials={getInitials(ORGANIZATION_COLLECTION, model.name)}
        avatarColor={AvatarColors.getColor(model.avc)}
        avatarFontColor={AvatarColors.getFontColor(model.avc)}
        url={model.avatar ? model.avatar.url : null}
        displayWidth={32}
        displayHeight={32}
        targetWidth={38}
        targetHeight={38}
      />
      <div className="OrgCard__nameWrapper">
        <span className="OrgCard__name">
          {model.name}
        </span>
      </div>
      <Button
        className="OrgCard__optionsButton"
        iconClass="ion-chevron-down"
        bindParam={model}
        onClick={props.onShowOptions}
      />
      <span className="OrgCard__description">
        {model.description}
      </span>
      <span className="OrgCard__pocLabel">
        <I18nMessage message="organizations.poc.header.label" />
      </span>
      <PeopleItem
        className="OrgCard__poc"
        isSimple={true}
        showName={true}
        model={model.poc}
        avatarImageWidth={20}
        avatarImageHeight={20}
      />
    </ListItem>
  );
}

OrgCardView.propTypes = {
  className: T.string,
  model: orgModelShape.isRequired,

  onClick: T.func,
  onShowOptions: T.func,
};

OrgCardView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/organizations/components/OrgCard/OrgCardView.js